<template>
  <component
    :is="`${iconName}`"
    v-if="icon"
    :icon="icon"
    :class="['zg-icon', {
      [`zg-icon--${color}`] : color,
      [`zg-icon--${size}`] : size,
      [`zg-icon--${rotate}`] : rotate
    }]"
  />
</template>

<script>

  export default {
    name: 'ZgIcon',
    components: {
      Add: () => import('./icons/Add.vue'),
      Apartment: () => import('./icons/Apartment.vue'),
      ArrowBack: () => import('./icons/ArrowBack.vue'),
      ArrowForward: () => import('./icons/ArrowForward.vue'),
      Assignment: () => import('./icons/Assignment.vue'),
      BankIdFi: () => import('./icons/BankIdFI.vue'),
      BankIdNo: () => import('./icons/BankIdNO.vue'),
      BankIdSe: () => import('./icons/BankIdSE.vue'),
      Business: () => import('./icons/Business.vue'),
      Cached: () => import('./icons/Cached.vue'),
      Calendar: () => import('./icons/Calendar.vue'),
      Cancel: () => import('./icons/Cancel.vue'),
      Caret: () => import('./icons/Caret.vue'),
      Chat: () => import('./icons/Chat.vue'),
      Check: () => import('./icons/Check.vue'),
      CheckBox: () => import('./icons/CheckBox.vue'),
      CheckBoxOutline: () => import('./icons/CheckBoxOutline.vue'),
      CheckCircle: () => import('./icons/CheckCircle.vue'),
      Chevron: () => import('./icons/Chevron.vue'),
      Choose: () => import('./icons/Choose.vue'),
      Close: () => import('./icons/Close.vue'),
      CloudDownload: () => import('./icons/CloudDownload.vue'),
      Compare: () => import('./icons/Compare.vue'),
      Compress: () => import('./icons/Compress.vue'),
      Delete: () => import('./icons/Delete.vue'),
      DeleteOutline: () => import('./icons/DeleteOutline.vue'),
      Description: () => import('./icons/Description.vue'),
      Edit: () => import('./icons/Edit.vue'),
      EuroSymbol: () => import('./icons/EuroSymbol.vue'),
      Expand: () => import('./icons/Expand.vue'),
      Facebook: () => import('./icons/Facebook.vue'),
      Favorite: () => import('./icons/Favorite.vue'),
      FavoriteBorder: () => import('./icons/FavoriteBorder.vue'),
      FrejaEid: () => import('./icons/FrejaEid.vue'),
      FrejaEidOval: () => import('./icons/FrejaEidOval.vue'),
      Leaf: () => import('./icons/Leaf.vue'),
      LightBulb: () => import('./icons/LightBulb.vue'),
      Help: () => import('./icons/Help.vue'),
      HelpOutline: () => import('./icons/HelpOutline.vue'),
      Home: () => import('./icons/Home.vue'),
      iArticle: () => import('./icons/Article.vue'),
      iFilter: () => import('./icons/Filter.vue'), // complained when used Filter "reserve HTML element"
      Forward: () => import('./icons/Forward.vue'),
      iLine: () => import('./icons/Line.vue'), // complained when used Line "reserve HTML element",
      Info: () => import('./icons/Info.vue'),
      LinkedIn: () => import('./icons/LinkedIn.vue'),
      iMenu: () => import('./icons/Menu.vue'), // complained when used Menu "reserve HTML element"
      MedicalServices: () => import('./icons/MedicalServices.vue'),
      More: () => import('./icons/More.vue'),
      Notification: () => import('./icons/Notification.vue'),
      OpenInNew: () => import('./icons/OpenInNew.vue'),
      Person: () => import('./icons/Person.vue'),
      Pin: () => import('./icons/Pin.vue'),
      PlaylistAddCheck: () => import('./icons/PlaylistAddCheck.vue'),
      Print: () => import('./icons/Print.vue'),
      QueryStats: () => import('./icons/QueryStats.vue'),
      RadioButtonChecked: () => import('./icons/RadioButtonChecked.vue'),
      RadioButtonUnchecked: () => import('./icons/RadioButtonUnchecked.vue'),
      RadioSelected: () => import('./icons/RadioSelected.vue'),
      RadioUnselected: () => import('./icons/RadioUnselected.vue'),
      Reload: () => import('./icons/Reload.vue'),
      Report: () => import('./icons/Report.vue'),
      ReportOutlined: () => import('./icons/ReportOutlined.vue'),
      Security: () => import('./icons/Security.vue'),
      Save: () => import('./icons/Save.vue'),
      Send: () => import('./icons/Send.vue'),
      SentimentalDissatisfied: () => import('./icons/SentimentalDissatisfied.vue'),
      SentimentalNeutral: () => import('./icons/SentimentalNeutral.vue'),
      SentimentalSatisfied: () => import('./icons/SentimentalSatisfied.vue'),
      SentimentalVeryDissatisfied: () => import('./icons/SentimentalVeryDissatisfied.vue'),
      SentimentalVerySatisfied: () => import('./icons/SentimentalVerySatisfied.vue'),
      SentimentalNoValue: () => import('./icons/SentimentalNoValue.vue'),
      Settings: () => import('./icons/Settings.vue'),
      Search: () => import('./icons/Search.vue'),
      Sign: () => import('./icons/Sign.vue'),
      SmileyVeryHappy: () => import('./icons/SmileyVeryHappy.vue'),
      Sort: () => import('./icons/Sort.vue'),
      Star: () => import('./icons/Star.vue'),
      Stars: () => import('./icons/Star.vue'),
      StarBorder: () => import('./icons/StarBorder.vue'),
      Tag: () => import('./icons/Tag.vue'),
      Timer: () => import('./icons/Timer.vue'),
      ThumbDown: () => import('./icons/ThumbDown.vue'),
      ThumbUp: () => import('./icons/ThumbUp.vue'),
      Todo: () => import('./icons/Todo.vue'),
      Tooltip: () => import('./icons/Tooltip.vue'),
      Twitter: () => import('./icons/Twitter.vue'),
      User: () => import('./icons/User.vue'),
      Logout: () => import('./icons/Logout.vue'),
      Phone: () => import('./icons/Phone.vue'),
      Confirmation: () => import('./icons/Confirmation.vue'),
      Verified: () => import('./icons/Verified.vue'),
      Warning: () => import('./icons/Warning.vue'),
      Error: () => import('./icons/Error.vue'),
      TooltipQuestionMark: () => import('./icons/TooltipQuestionMark.vue'),
      TooltipArrow: () => import('./icons/TooltipArrow.vue'),
      Play: () => import('./icons/Play.vue'),
      Valid: () => import('./icons/Valid.vue'),
      Mail: () => import('./icons/Mail.vue'),
      iLink: () => import('./icons/Link.vue')
    },
    props: {
      icon: {
        type: String,
        required: true
      },
      color: {
        type: String,
        required: false,
        default: 'black',
        validator: value => [
          'black',
          'white',
          'brand-500',
          'brand-300',
          'brand-100',
          'primary-500',
          'secondary-500',
          'accent-500',
          'accent-300',
          'accent-100',
          'info-500',
          'info-300',
          'info-100',
          'error-500',
          'warning-500',
          'success-500',
          'success-300',
          'success-100',
          'gray-500',
          'gray-300',
          'gray-200',
          'beige'
        ].includes(value)
      },
      size: {
        type: String,
        required: false,
        default: 'small',
        validator: value => [
          'xxsmall',
          'xsmall',
          'small',
          'medium',
          'large'
        ].includes(value)
      },
      rotate: {
        type: String,
        required: false,
        default: '0',
        validator: value => [
          '0',
          '90',
          '180',
          '270'
        ].includes(value)
      }
    },
    computed: {
      iconName () {
        return ['filter', 'menu', 'line', 'article', 'link'].includes(this.icon) ? `i-${this.icon}` : this.icon
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-icon {
    // ? ----------------------------------------------------------------------
    // colors
    // ? ----------------------------------------------------------------------

    &--black {
      color: color(black);
    }

    &--white {
      color: color(white);
    }

    &--brand-500 {
      color: color(brand-500);
    }

    &--brand-300 {
      color: color(brand-300);
    }

    &--brand-100 {
      color: color(brand-100);
    }

    &--primary-500 {
      color: color(primary-500);
    }

    &--secondary-500 {
      color: color(secondary-500);
    }

    &--accent-500 {
      color: color(accent-500);
    }

    &--accent-300 {
      color: color(accent-300);
    }

    &--accent-100 {
      color: color(accent-100);
    }

    &--info-500 {
      color: color(info-500);
    }

    &--info-300 {
      color: color(info-300);
    }

    &--info-100 {
      color: color(info-100);
    }

    &--error-500 {
      color: color(error-500);
    }

    &--warning-500 {
      color: color(warning-500);
    }

    &--success-500 {
      color: color(success-500);
    }

    &--success-300 {
      color: color(success-300);
    }

    &--success-100 {
      color: color(success-100);
    }

    &--gray-500 {
      color: color(gray-500);
    }

    &--gray-300 {
      color: color(gray-300);
    }

    &--gray-200 {
      color: color(gray-200);
    }

    &--beige {
      color: color(beige)
    }

    // ? ----------------------------------------------------------------------
    // sizes
    // ? ----------------------------------------------------------------------

    &--xxsmall {
      height: rem(12px);
      width: rem(12px);
    }

    &--xsmall {
      height: rem(16px);
      width: rem(16px);
    }

    &--small {
      height: rem(24px);
      width: rem(24px);
    }

    &--medium {
      height: rem(32px);
      width: rem(32px);
    }

    &--large {
      height: rem(64px);
      width: rem(64px);
    }

    // ? ----------------------------------------------------------------------
    // rotation
    // ? ----------------------------------------------------------------------

    &--90 {
      transform: rotate(90deg);
    }

    &--180 {
      transform: rotate(180deg);
    }

    &--270 {
      transform: rotate(270deg);
    }
  }
</style>
